import { render, staticRenderFns } from "./pagination-component.vue?vue&type=template&id=d3c508c2&scoped=true"
import script from "./pagination-component.vue?vue&type=script&lang=js"
export * from "./pagination-component.vue?vue&type=script&lang=js"
import style0 from "./pagination-component.vue?vue&type=style&index=0&id=d3c508c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c508c2",
  null
  
)

export default component.exports